export enum OperationStatus {
    all = 0,
    created = 1,
    pending = 2,
    cancelled = 3,
    verified = 4,
    rejected = 5,
    finalized = 6,
    notified = 7,
    returned = 8,
    trasferred = 9,
    waitingFounds = 10
}
